"use client";

import { m, AnimatePresence } from "motion/react";

interface CalculatorResultCardAnimatorProps {
  /** Re-mounts the inner card when this changes — drives the cross-fade animation. */
  animationKey: string;
  /** Stable id used by `motion`'s shared layout transitions. */
  layoutId: string;
  children: React.ReactNode;
}

const INITIAL = { opacity: 0.7 };
const ANIMATE = { opacity: 1 };
const EXIT = { opacity: 0.7 };
const TRANSITION = { duration: 0.2, delay: 0.1 };

/**
 * Standard cross-fade + shared-layout wrapper used around calculator result cards.
 * Same motion params as the agents/default tier card and the API PAYG/Subscription
 * result cards — keep them in sync by routing both through this component.
 */
export function CalculatorResultCardAnimator({ animationKey, layoutId, children }: CalculatorResultCardAnimatorProps) {
  return (
    <AnimatePresence mode='popLayout' initial={false}>
      <m.div
        key={animationKey}
        layout
        layoutId={layoutId}
        initial={INITIAL}
        animate={ANIMATE}
        exit={EXIT}
        transition={TRANSITION}
      >
        {children}
      </m.div>
    </AnimatePresence>
  );
}
